'use strict';
var localisations = require('./passwords.localisations');

export default class PasswordsController {
  /*@ngInject*/
  constructor(User, common, Auth, $timeout, groups) {
    // Use the User $resource to fetch all users
    var that = this;
    this.users = User.query();
    this.Auth = Auth;
    this.$timeout = $timeout;
    this.groups = groups;
    this.changeList = [];
    this.common = common;
    this.common.setBack(null, null);
    this.localisations = localisations[this.common.getLocale()];
    this.filterText = '';
    this.updatedPasswords = [];
  }

  toggleUser(id) {
    var clIndex = this.changeList.map(function(u){
      return u._id;
    }).indexOf(id);
    var uIndex = this.users.map(function(u){
      return u._id;
    }).indexOf(id);
    if(clIndex > -1) {
      this.users[uIndex].pChange = false;
      this.changeList.splice(clIndex, 1);
    } else {
      this.users[uIndex].pChange = true;
      this.changeList.push(this.users[uIndex]);
    }
  }

  filteredUsers() {
    var that = this;
    if(this.filterText === '') {
      return this.users;
    } else {
      return this.users.filter(function(u) {
        return u.name.toLowerCase().indexOf(that.filterText.toLowerCase()) > -1 || u.email.toLowerCase().indexOf(that.filterText.toLowerCase()) > -1;
      });
    }
  }

  changePasswords() {
    var that = this;
    let newPassword;
    for(var pw = 0; pw < this.changeList.length; pw++){
      newPassword = 'foeface' + (Math.floor(1000 + Math.random() * 9000)).toString();
      console.log('New Password for ', this.changeList[pw].name, ' is ', newPassword);
      this.changeList[pw].newPassword = newPassword;
    }
    // call service to update
    // create PDF and download
    // Remove Items from list.
    this.Auth.bulkResetPassword(that.changeList, function() {
      that.$timeout(function() {
        that.common.setQuickNotification('Passwords Updated.', 'success');
      }, 400);
      for(var c = 0; c < that.changeList.length; c++) {
        that.updatedPasswords.push({
          name: that.changeList[c].name,
          email: that.changeList[c].email,
          password: that.changeList[c].newPassword,
        });
        that.groups.printPdf(that.updatedPasswords, function() {}, function() {});
        that.changeList[c].pChange = false;
      }
      that.changeList.length = 0;
    }, function() {
      that.common.setAlert('Save Error', 'danger', 'Looks like there was a problem updating the passwords. Please try again.', false, true);
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/passwords.controller.js